var exports = {
  "n": "xe533113f--d5e721--link",
};

module.exports = exports;
